import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import styles from './WhatsAppButton.module.css';

const WhatsAppButton = ({ branding }) => {
  // 1. Safely extract the phone number from branding
  // Fallback priority: whatsappNumber -> phones array -> single phone -> default dummy number
  const rawNumber = 
    branding?.whatsapp || 
    (branding?.phones && branding.phones[0]) || 
    branding?.phone || 
    "+91 0000000000";

  // 2. WhatsApp API requires numbers without +, -, or spaces
  const cleanNumber = rawNumber.replace(/[^0-9]/g, '');
const companyName = branding?.companyName || "your agency";

const defaultMessage =
`Hello ${companyName}, I saw your website and would like to know more about your travel packages.`;
  // 4. Construct the official WhatsApp URL
  const whatsappUrl = `https://wa.me/${cleanNumber}?text=${encodeURIComponent(defaultMessage)}`;

  return (
  <div className={styles.whatsappContainer}>
    
    <div className={styles.tooltip}>
      Chat with us
    </div>

    <a 
      href={whatsappUrl} 
      target="_blank" 
      rel="noopener noreferrer" 
      className={styles.floatButton}
      aria-label="Chat with us on WhatsApp"
    >
      <FaWhatsapp className={styles.icon} />
    </a>

  </div>
);
}
export default WhatsAppButton;